import { Box, Typography, useTheme } from "@mui/material";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import React from "react";
import { IStandardCardProps } from "./interfaces/ICardsProps";

// export const StandardCard: React.FC<IStandardCardProps> = (props) => {
//   const { heading, rightHeading, sx, variant = 'normal' } = props;

//   const isNode = React.isValidElement(rightHeading);

//   return (
//     <Card
//       sx={{
//         margin: 0,
//         borderRadius: "20px",
//         padding: variant === 'normal' ? '20px' : '10px',
//         boxShadow: "rgba(90, 114, 123, 0.11) 0px 7px 30px 0px",
//         ...sx,
//       }}
//     >
//       <Box display="flex" justifyContent={"space-between"} alignItems="center">
//         {heading ? <Typography variant="h2" fontWeight={"700"}>
//           {heading}
//         </Typography> : <Box></Box>}
//         {isNode && <Box>{rightHeading}</Box>}
//         {!isNode && (
//           <Typography variant="body1" fontWeight={"400"}>
//             {rightHeading}
//           </Typography>
//         )}
//       </Box>
//       {heading && <Divider sx={{ mt: 2, mb: 2 }} />}
//       {props.children}
//     </Card>
//   );
// };

export const StandardCard: React.FC<IStandardCardProps> = (props) => {
  const {
    heading,
    rightHeading,
    sx,
    variant = "normal",
    renderWithoutCard = false,
    headingCenter = false,
    onHeaderClick,
    hideHeadingDivider = false,
  } = props;
  const theme = useTheme();

  const isNode = React.isValidElement(rightHeading);

  if (renderWithoutCard) {
    return (
      <Box>
        {(heading || rightHeading) && (
          <Box
            display="flex"
            justifyContent={headingCenter ? "center" : "space-between"}
            alignItems="flex-start"
            onClick={onHeaderClick}
            sx={{
              flexWrap: { xs: "wrap", sm: "nowrap" },
              gap: { xs: 1, sm: 0 },
              cursor: onHeaderClick ? "pointer" : "default",

              "&:hover": onHeaderClick
                ? {
                    opacity: 0.85,
                  }
                : {},
            }}
          >
            {heading ? (
              <Typography
                variant="h2"
                fontSize={{
                  xs: "0.75rem",
                  sm: "0.9rem",
                  md: "1.1rem",
                  lg: "1.2rem",
                }}
                fontWeight={"700"}
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  flex: 1,
                  minWidth: 0,
                }}
              >
                {heading}
              </Typography>
            ) : (
              <Box></Box>
            )}
            {isNode && (
              <Box
                fontWeight={"400"}
                sx={{
                  flexShrink: 0,
                  [theme.breakpoints.down("sm")]: {
                    width: "100%",
                  },
                }}
              >
                {rightHeading}
              </Box>
            )}
            {!isNode && (
              <Typography variant="body1" fontWeight={"400"}>
                {rightHeading}
              </Typography>
            )}
          </Box>
        )}
        {heading && !hideHeadingDivider && (
          <Divider
            sx={{
              mt: 1,
              mb: 1,
              [theme.breakpoints.up("md")]: {
                mt: 0.8,
                mb: 0.8,
              },
              [theme.breakpoints.up("lg")]: {
                mt: 1,
                mb: 1,
              },
              [theme.breakpoints.up("xl")]: {
                mt: 1.5,
                mb: 1.5,
              },
            }}
          />
        )}
        {props.children}
      </Box>
    );
  }

  return (
    <Card
      sx={{
        "--parent-bg": "#fff",
        backgroundColor: "#fff",
        margin: 0,
        borderRadius: 2.4,
        padding: "1rem",
        boxShadow: "rgba(90, 114, 123, 0.11) 0px 7px 30px 0px",
        border: 0,
        [theme.breakpoints.up("md")]: {
          padding: variant === "normal" ? 1.5 : "10px",
          borderRadius: 2.4,
        },
        [theme.breakpoints.up("lg")]: {
          padding: variant === "normal" ? 1.5 : "10px",
          borderRadius: 2.4,
        },
        [theme.breakpoints.up("xl")]: {
          padding: variant === "normal" ? 1.5 : "10px",
          borderRadius: 2.4,
        },

        ...sx,
      }}
    >
      {(heading || rightHeading) && (
        <Box
          display="flex"
          justifyContent={headingCenter ? "center" : "space-between"}
          alignItems="center"
          onClick={onHeaderClick}
          sx={{
            minHeight: 32,
            flexWrap: { xs: "wrap", sm: "nowrap" },
            gap: { xs: 1, sm: 0 },
            cursor: onHeaderClick ? "pointer" : "default",

            "&:hover": onHeaderClick
              ? {
                  opacity: 0.85,
                }
              : {},
          }}
        >
          {heading ? (
            <Typography
              variant="h2"
              fontSize={{
                xs: "0.75rem",
                sm: "0.9rem",
                md: "1.1rem",
                lg: "1.2rem",
              }}
              fontWeight={"700"}
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                flex: { xs: "0 1 auto", sm: 1 },
                minWidth: 0,
              }}
            >
              {heading}
            </Typography>
          ) : (
            <Box></Box>
          )}
          {isNode && (
            <Box
              fontWeight={"400"}
              sx={{
                flexShrink: 0,
                ml: { xs: "auto", sm: 0 },
              }}
            >
              {rightHeading}
            </Box>
          )}
          {!isNode && (
            <Typography variant="body1" fontWeight={"400"}>
              {rightHeading}
            </Typography>
          )}
        </Box>
      )}
      {heading && !hideHeadingDivider && (
        <Divider
          sx={{
            mt: 1,
            mb: 1,
            [theme.breakpoints.up("md")]: {
              mt: 0.8,
              mb: 0.8,
            },
            [theme.breakpoints.up("lg")]: {
              mt: 1,
              mb: 1,
            },
            [theme.breakpoints.up("xl")]: {
              mt: 1.5,
              mb: 1.5,
            },
          }}
        />
      )}
      {props.children}
    </Card>
  );
};
